import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
    Icon,
    Spin,
    Layout,
    Modal,
    Button,
    Checkbox,
    Divider,
    message,
} from 'antd'
import AddCardForm from '../../components/Billing/AddCardForm'
import CloudFlyerAPI from '../../api/CloudFlyerAPI'
import { refresh_profile } from '../../actions/auth'

import SecureLockIcon from '../../assets/img/security-lock.png'

import './style.scss'

class PricingModal extends React.Component {
    constructor(props) {
        super(props)

        const { is_cbs } = (this.props.user || {}).organization || {}
        this.state = {
            period: 'monthly',
            confirmed: false,
            visible: this.props.visible !== undefined ? !is_cbs : true,
            addCardVisible: false,
            loading: false,
            cc: {
                firstName: '',
                lastName: '',
                number: '',
                expiry: '',
                cvc: '',
                focused: 'number',
                valid: false,
            },
        }

        this.handleClick = this.handleClick.bind(this)
        this.handleCheckConfirm = this.handleCheckConfirm.bind(this)
        this.handleConfirm = this.handleConfirm.bind(this)
        this.handleCancel = this.handleCancel.bind(this)
        this.handleCCFocus = this.handleCCFocus.bind(this)
        this.handleCCChange = this.handleCCChange.bind(this)
        this.ccCallback = this.ccCallback.bind(this)
        this.confirm = this.confirm.bind(this)
        this.sendRequest = this.sendRequest.bind(this)
    }

    componentDidMount() {}

    confirm() {
        const { period, cc } = this.state
        const {
            product,
            user: { has_billing_info },
        } = this.props
        const productToHandle = {
            search:
                'CloudFlyer-litemam-' +
                (period === 'monthly' ? 'monthly' : 'annual'),
            analytics:
                'CloudFlyer-analytics-' +
                (period === 'monthly' ? 'monthly' : 'annual'),
            finance:
                'CloudFlyer-finance-' +
                (period === 'monthly' ? 'monthly' : 'annual'),
        }

        let queryObj = {
            customer_subscription: {
                subscription: {
                    product_handle: productToHandle[product],
                    coupon_code: '',
                },
            },
        }

        if (!has_billing_info) {
            queryObj['customer_subscription']['subscription'][
                'credit_card_attributes'
            ] = {
                full_number: cc.number,
                first_name: cc.firstName,
                last_name: cc.lastName,
                expiration_month: cc.expiry.slice(0, 2),
                expiration_year: cc.expiry.slice(2, 4),
                billing_address: '',
                billing_city: '',
                billing_state: '',
                billing_country: '',
                billing_zip: '',
            }
        }

        this.setState({ loading: true })

        CloudFlyerAPI.billing
            .subscriptions(queryObj)
            .then(() => {
                message.success('Service activated')
                this.setState({ visible: false, loading: false })
                this.props.refresh_profile(true)
                if (this.props.controlVisibility) this.props.onCancel()
            })
            .catch(error => {
                this.setState({ loading: false })
                if (error.response) {
                    console.log(error.response.data.message)
                    message.error(error.response.data.message)
                }
            })
    }

    sendRequest() {
        const { product, history } = this.props
        const { period } = this.state
        this.setState({ loading: true })

        CloudFlyerAPI.packages
            .request_service(product, period)
            .then(res => {
                this.setState({ loading: false })
                history.push('/')
                message.success('Request has been sent to the owner')
            })
            .catch(error => {
                this.setState({ loading: false })
                if (error.response) {
                    console.log(error.response.data.message)
                    message.error(error.response.data.message)
                }
            })
    }

    handleCCFocus(target) {
        this.setState({
            cc: {
                ...this.state.cc,
                focused:
                    target.name === 'firstName' || target.name === 'lastName'
                        ? 'name'
                        : target.name,
            },
        })
    }

    handleCCChange(target) {
        const cc = { ...this.state.cc }

        if (target.name === 'number') {
            cc[target.name] = target.value.replace(/ /g, '')
        } else if (target.name === 'expiry') {
            cc[target.name] = target.value.replace(/[ \/]/g, '')
        } else {
            cc[target.name] = target.value
        }

        this.setState({ cc })
    }

    ccCallback(type, isValid) {
        this.setState({
            cc: {
                ...this.state.cc,
                valid: isValid,
            },
        })
    }

    handleClick(period) {
        this.setState({ period, confirmed: false, addCardVisible: false })
    }

    handleCheckConfirm(e) {
        const newState = { ...this.state }
        newState['confirmed'] = e.target.checked
        if (!e.target.checked) {
            newState['addCardVisible'] = false
        }
        this.setState(newState)
    }

    handleConfirm() {
        const { period } = this.state
        const {
            user: { has_billing_info },
        } = this.props
        const role = this.props.user.role.title
        if (role === 'Owner') {
            if (has_billing_info) {
                this.confirm()
            } else {
                this.setState({ addCardVisible: true, confirmed: true })
            }
        } else {
            this.setState({ confirmed: true })
            console.log('sending request .. ')
            this.sendRequest()
        }

        this.props.onClose(period)
    }

    handleCancel() {
        const { controlVisibility, onCancel, history } = this.props
        if (controlVisibility) onCancel()
        else {
            this.setState({ visible: false })
            history.push('/')
        }
    }

    render() {
        const {
            productName,
            monthlyPricing,
            annuallyPricing,
            user,
            controlVisibility,
            show,
        } = this.props
        const {
            period,
            confirmed,
            visible,
            cc,
            addCardVisible,
            loading,
        } = this.state
        const role = ((user || {}).role || {}).title
        const confirmMsg =
            period === 'monthly'
                ? `$${monthlyPricing} per month`
                : `$${annuallyPricing} per year`

        return (
            <Modal
                className="pricing-modal"
                wrapClassName="wrap-pricing-modal"
                visible={controlVisibility ? show : visible}
                width={700}
                onCancel={this.handleCancel}
                footer={
                    addCardVisible && (
                        <div className="footer-msg">
                            <p>
                                Once you add your card, it will be charged the
                                agreed upon amount and will be saved.
                            </p>
                            <p>
                                You will always receive a confirmation email
                                following any transaction.
                            </p>
                            <div className="secure-form-txt">
                                <img
                                    alt="secure lock icon"
                                    src={SecureLockIcon}
                                />
                                &nbsp; Secure Form
                            </div>
                        </div>
                    )
                }>
                <Spin spinning={loading}>
                    {role === 'Owner' ? (
                        <h1>{`Start using CloudFlyer ${productName}`}</h1>
                    ) : (
                        <h1>{`Request to add ${productName}`}</h1>
                    )}
                    <p>
                        {`
           Begin using ${productName} immediately by choosing the plan that works best for you.
           `}
                        <br />
                        {role === 'Owner'
                            ? 'Your account will be charged once you confirm.'
                            : 'We will email the account owner to approve the request.'}
                    </p>
                    <div className="buttons">
                        <Button
                            type={period === 'monthly' ? 'primary' : 'normal'}
                            size="large"
                            onClick={() => this.handleClick('monthly')}>
                            {`Monthly $${monthlyPricing}`}
                        </Button>
                        <Button
                            type={period === 'annually' ? 'primary' : 'normal'}
                            size="large"
                            onClick={() => this.handleClick('annually')}>
                            {`Annually $${annuallyPricing}`}
                        </Button>
                    </div>
                    <div className="confirm-checkbox">
                        <Checkbox
                            onChange={this.handleCheckConfirm}
                            checked={confirmed}>
                            {role === 'Owner'
                                ? `I acknowledge my account will be charged ${confirmMsg} for CloudFlyer's ${productName} feature.`
                                : `${period} subscription to CloudFlyer's ${productName} feature.`}
                        </Checkbox>
                    </div>
                    <div className="confirm-container">
                        <Button
                            disabled={!confirmed || addCardVisible}
                            size="large"
                            type="primary"
                            onClick={this.handleConfirm}>
                            {role === 'Owner' ? 'Confirm' : 'Send Request'}
                        </Button>
                    </div>
                    {addCardVisible && (
                        <div>
                            <Divider>
                                <h3>Add Credit Card</h3>
                            </Divider>
                            <AddCardForm
                                loading={false}
                                on_save={this.confirm}
                                on_cancel={() => console.log('canceling ..')}
                                name={cc.name}
                                number={cc.number}
                                expiry={cc.expiry}
                                cvc={cc.cvc}
                                focused={cc.focused}
                                callback={this.ccCallback}
                                on_focus={this.handleCCFocus}
                                on_change={this.handleCCChange}
                                valid={cc.valid}
                                cardPosition="none"
                            />
                        </div>
                    )}
                </Spin>
            </Modal>
        )
    }
}

function mapStateToProps({ auth: { user } }) {
    return { user }
}

function mapDispatchToProps(dispatch) {
    return { refresh_profile: () => dispatch(refresh_profile(true)) }
}

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(PricingModal)
)
